import Box from "@mui/material/Box"
import { Outlet } from "react-router-dom"

import AccountPageLeftDrawer from "@layouts/account_navigation_layout/sub_components/left_drawer"
import BaseLayout from "@layouts/base_layout"

import { AccountPageContextProvider } from "@contexts/account"
import styles from "./styles"

export default function AccountNavigationLayout() {
  return (
    <BaseLayout>
      <AccountPageContextProvider>
        <Box sx={styles.contextContainer}>
          <AccountPageLeftDrawer />
          <Box sx={styles.contentAreaContainer}>
            <Outlet />
          </Box>
        </Box>
      </AccountPageContextProvider>
    </BaseLayout>
  )
}
